<template>
  <div class="header">
    <div class="container">
      <!-- logo -->
      <img
        :src="
          $route.name === 'Home' ? imagePath.zdLogo : imagePath.luojigouLogo
        "
        :class="['logo','cp',  $route.name === 'Home' ? 'zdLogo' : '']"
        @click="$route.name !== 'Home' ? $router.push('/') : ''"
      />
      <div class="nav">
        <!-- 搜索框 -->
        <div class="search cp">
          <div v-if="$route.name !== 'Home'" class="goSearch">
            <input
              ref="searchInput"
              v-show="searchInputIsShow"
              class="searchInput"
              :style="{
                boxShadow: `0px 0px 0px 6px ${searchShadowColor}`,
                border: `1px solid ${searchBorderColor}`,
              }"
              type="search"
              v-model="searchText"
              @keyup.enter="goSearch()"
              @blur="inputBlur"
              @focus="search(searchText)"
            />
            <img
              v-if="searchInputIsShow"
              :src="imagePath.closeBtn"
              class="deleteSearchText cp"
              @click.stop="deleteSearchText()"
            />
            <img
              ref="searchLogo"
              :src="imagePath.search"
              class="searchLogo cp"
              @click="goSearch"
            />
          </div>
          <!-- 搜索列表 -->
          <div
            class="searchList"
            v-if="searchListShow && searchList.length !== 0"
          >
            <div
              class="item"
              v-for="(item, index) in searchList"
              :key="index"
              v-html="item.nameHighlights"
              @click.stop="clickSearch(item.name)"
            ></div>
          </div>
          <!-- 遮罩层 -->
          <div
            class="searchListMask"
            v-if="searchInputIsShow"
            @click="handleMaskShow"
          ></div>
        </div>
        <!-- 返回首页按钮 -->
        <div
          v-if="$route.name !== 'Home'"
          class="goHome cp"
          @click="$router.push('/home')"
        >
          <img :src="imagePath.home" />
          <div>首页</div>
        </div>
        <!-- 去学习记录页面按钮 -->
        <div
          v-if="$route.name !== 'Home'"
          :class="[
            'goHistory',
            'cp',
            $route.path === '/my' ? 'goHistoryed' : '',
          ]"
          @click="lookAll"
          @mouseover="$forceUpdate()"
        >
          <div class="goHistoryContent">
            <img
              :src="
                $route.path === '/my' ? imagePath.historyed : imagePath.history
              "
            />
            <div class="lr">学习记录</div>
          </div>
          <div class="LRContainor">
            <!-- 三角形 -->
            <div class="triangleUp"></div>
            <div class="LRList">
              <div v-if="learningRecordList.length !== 0" class="cardImg">
                <div
                  class="mask"
                  @click.stop="goCourseDetails(courseItem.catId)"
                >
                  <div class="maskTitle">学习记录</div>
                </div>
                <img v-if="courseItem.imgUrl" :src="courseItem.imgUrl" />
              </div>

              <div class="cardText">
                <div class="title">近七天学习记录</div>
                <div
                  v-if="learningRecordList.length !== 0"
                  class="clear cp"
                  @click.stop="deleteBrowserHistory()"
                >
                  <img :src="imagePath.clearImg" /><span>清除所有</span>
                </div>
              </div>
              <div class="cardList1" v-if="learningRecordList.length !== 0">
                <div
                  class="cardItem"
                  v-for="item in learningRecordList"
                  :key="item.recordId"
                >
                  <img class="logo" :src="imagePath.lrList" alt="" />
                  <div class="classLevelName">{{ item.classLevelName }}</div>
                  <div class="cont">
                    <div>
                      <div class="title">{{ item.slidesName }}</div>
                      <div class="updateTime">
                        <img :src="imagePath.updateTime" alt="" />
                        <span>{{ item.createTime }}</span>
                      </div>
                    </div>
                    <img
                      :src="imagePath.closeBtn"
                      class="close cp"
                      @click.stop="deleteOneBrowserHistory(item.recordId)"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="learningRecordList.length !== 0"
                class="lookAll cp"
                :style="{
                  border: `1px solid ${lookAllBorderColor}`,
                  color: lookAllBorderColor,
                }"
                @click="lookAll"
              >
                查看全部
              </div>

              <no-data v-if="learningRecordList.length === 0"></no-data>
            </div>
          </div>
        </div>
        <!-- 我的资料 -->
        <div class="goUserInfo">
          <span>{{ userInfo.schoolName }}</span>
          <div class="minCont">
            <img
              :src="userInfo.imgUrl || imagePath.luojigouMini"
              alt=""
              class="miniAvatar cp"
            />
            <div class="infoContent">
              <!-- 三角形 -->
              <div class="triangleUp"></div>
              <div class="infoList cp">
                <!-- <div class="infoItem">我的课件</div>
                <div class="infoItem">我的收藏</div> -->
                <div class="infoItem" @click="loginOut">退出登录</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal></modal>
  </div>
</template>

<script>
import modal from "@/components/modal/index";
import { mapState, mapActions } from "vuex";
import { searchList } from "@/api/home";
import { logout } from "@/api/login.js";
import {
  queryBrowsingRecordsLast,
  queryBrowsingRecords,
  deleteOneBrowserHistory,
  deleteBrowserHistory
} from "@/api/my";
import imagePath from "@/utils/imagePath";
import {
  borderColorArrByIndex,
  shadowColorArrByIndex
} from "@/utils/getColor.js";
import noData from "@/components/noData.vue";
import { imgUrlEncode } from "@/utils/tool.js";

export default {
  name: "Header",
  components: {
    noData,
    modal
  },
  data() {
    return {
      shadowColorArrByIndex,
      borderColorArrByIndex,
      imagePath,
      searchShow: false, // 头部搜索框是否显示
      searchText: "", // 搜索文本
      timer: "", // 搜索防抖定时器
      searchList: [], // 搜索出来的列表
      searchListShow: false, // 搜索列表显示
      learningRecordList: [], // 学习记录列表
      courseItem: { imgUrl: "" }, // 最近学习的一个课程
      searchInputIsShow: false, // 搜索输入框是否显示
      classNum: 0, // 年级索引
      lrIsShow: false // 学习记录详情是否显示
    };
  },
  watch: {
    searchText(val) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      if (!this.searchText) {
        this.searchList = [];
      } else {
        this.timer = setTimeout(() => {
          this.search(val);
        }, 500);
      }
    },
    searchInputIsShow(val) {
      val ? "" : (this.searchText = "");
      setTimeout(() => {
        this.$refs.searchLogo.className = val
          ? "searchLogo searchLogoLeft"
          : "searchLogo";
        this.$refs.searchInput.className = val
          ? "searchInput searchInputWidth"
          : "searchInput";
        if (val) this.$refs.searchInput.focus();
      }, 0);
    }
  },
  computed: {
    ...mapState({ userInfo: (state) => state.user.userInfo }),
    lookAllBorderColor() {
      if (this.classNum === 0) {
        return "#FF6F5B";
      } else if (this.classNum === 1) {
        return "#9DD51F";
      } else if (this.classNum === 2) {
        return "#549AFF";
      } else if (this.classNum === 3) {
        return "#CF75FF";
      }
      return "FF6F5B";
    },
    searchShadowColor() {
      return shadowColorArrByIndex[this.classNum];
    },
    searchBorderColor() {
      return borderColorArrByIndex[this.classNum];
    }
  },
  created() {
    this.getClassNum();
    if (this.$route.path !== "/home") {
      this.queryBrowsingRecords();
      this.queryBrowsingRecordsLast();
    }
  },
  updated() {
    this.getClassNum();
  },
  methods: {
    ...mapActions({
      Logout: "Logout"
    }),
    getClassNum() {
      if (
        this.$route.path === "/my" ||
        this.$route.path === "/search" ||
        this.$route.path === "/lookPPT"
      ) {
        this.classNum = 2;
      } else {
        this.classNum = sessionStorage.getItem("classNum") * 1 || 0;
      }
    },
    // 清空搜索文本
    deleteSearchText() {
      this.searchText = "";
    },
    // 遮罩层隐藏
    handleMaskShow() {
      if (this.searchListShow) {
        this.searchListShow = false;
        return;
      }
      if (this.searchInputIsShow) {
        this.searchInputIsShow = false;
      }
    },
    inputBlur() {
    },
    // 跳转到课程详情
    goCourseDetails(id) {
      this.$router.push({
        path: "/courseDetails",
        query: { id: id, classNum: 0 }
      });
    },
    // 退出登录
    async loginOut() {
      const { data, msg, status } = await logout();
      if (status === 200) {
        console.log(data, "logout");
        localStorage.removeItem("token");
        await this.$router.push("/login");
      } else {
        this.$message.error(msg);
      }
    },
    // 查看全部
    lookAll() {
      if (this.$route.path !== "/my") this.$router.push("/my");
    },
    // 删除全部学习记录
    async deleteBrowserHistory() {
      if (this.learningRecordList.length === 0) return;
      const { status, msg } = await deleteBrowserHistory(this.userInfo.userId);
      if (status === 200) {
        this.$message.success("删除成功");
        await this.queryBrowsingRecords();
      } else {
        this.$message.error(msg);
      }
    },
    // 删除一条学习记录
    async deleteOneBrowserHistory(id) {
      const { status, msg } = await deleteOneBrowserHistory(id);
      if (status === 200) {
        this.$message.success("删除成功");
        await this.queryBrowsingRecords();
      } else {
        this.$message.error(msg);
      }
    },
    // 时间格式化 fmt时间格式 7天前
    dateFormat(fmt) {
      let currentDate = new Date();
      let oldDate = currentDate.setDate(currentDate.getDate() - 7);
      let date = new Date(oldDate);
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(), // 年
        "m+": (date.getMonth() + 1).toString(), // 月
        "d+": date.getDate().toString(), // 日
        "H+": date.getHours().toString(), // 时
        "M+": date.getMinutes().toString(), // 分
        "S+": date.getSeconds().toString() // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(
            ret[1],
            ret[1].length == 1 ? opt[k] : opt[k].padStart(ret[1].length, "0")
          );
        }
      }
      return fmt;
    },
    // 查询最近的一条二级学习记录
    async queryBrowsingRecordsLast() {
      const params = {
        userId: this.userInfo.userId
      };
      const { data, status, msg } = await queryBrowsingRecordsLast(params);
      if (status === 200) {
        if (data) {
          this.courseItem = data;
          const imgUrl = imgUrlEncode(data.imgUrl);
          this.courseItem.imgUrl = imgUrl;
        }
        // console.log(data, "queryBrowsingRecordsLast");
      } else {
        this.$message.error(msg);
      }
    },
    // 查询学习记录
    async queryBrowsingRecords() {
      const time = this.dateFormat("YYYY-mm-dd HH:MM:SS");
      const params = {
        updateTime: time,
        userId: this.userInfo.userId,
        page: 1,
        pageSize: 4
      };
      const { data, status, msg } = await queryBrowsingRecords(params);
      if (status === 200) {
        this.learningRecordList = data.entityList;
      } else {
        this.$message.error(msg);
      }
    },
    // 点击搜索
    clickSearch(val) {
      this.searchText = val;
      this.goSearch();
    },
    // 跳转到搜索页面
    goSearch() {
      if (!this.searchInputIsShow) {
        this.searchInputIsShow = true;
        return;
      }
      if (!this.searchText) {
        this.searchInputIsShow = false;
        return;
      }
      const searchText = this.searchText;
      this.searchListShow = false;
      this.searchInputIsShow = false;

      this.$router.push({
        path: "/search",
        query: {
          searchText: searchText
        }
      });
      this.searchText = "";
      // debugger;
      this.searchListShow = false;
      this.searchInputIsShow = false;
    },
    // 替换搜索文字
    changeText() {
      const search = this.searchText;
      this.searchList = this.searchList.map((item) => {
        for (let key in item) {
          if (key === "name") {
            let replaceReg = new RegExp(search, "g"); // 匹配关键字正则
            let replaceString = `<span class="highlights">${this.searchText}</span>`; // 高亮替换v-html值
            item[key + "Highlights"] = item[key].replace(
              replaceReg,
              replaceString
            ); // 开始替换
          }
        }
        return item;
      });
      // console.log(this.searchList, "searchList");
    },
    // 搜索
    async search(val) {
      if (!val) return;
      const { data, status, msg } = await searchList(val);
      if (status === 200) {
        this.searchList = data;
        this.searchListShow = this.searchList.length !== 0 ? true : false;
        this.changeText();
      } else {
        this.$message.error(msg);
      }
    }
  }
};
</script>

<style lang="less" scoped>
// 三角
.triangleUp {
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-bottom: 10px solid #fff;
  // box-shadow: 2px 6px 14px 8px rgba(47, 47, 47, 0.1);
}

.header {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 109px;

  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 1200px;

    .logo {
      width: 230px;
      height: 73px;
    }

    .zdLogo {
      width: 302px;
      height: 143px;
    }

    .nav {
      display: flex;
      justify-content: flex-end;
      align-items: center;

      .search {
        position: relative;

        .goSearch {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          z-index: 999;
          margin-right: 30px;
          width: 480px;
          height: 50px;

          .searchInput {
            position: absolute;
            right: 0;
            padding-left: 53px;
            width: 50px;
            height: 50px;
            background: #ffffff;
            box-shadow: 2px 6px 14px 8px rgba(57, 58, 62, 0.06);
            border-radius: 25px;
            transition: width 0.5s ease;
            box-sizing: border-box;
          }

          .searchInputWidth {
            width: 430px !important;
          }

          .deleteSearchText {
            position: absolute;
            top: 18px;
            right: 20px;
            width: 14px;
            height: 14px;
          }

          .searchLogo {
            position: absolute;
            left: 436px;
            top: 13px;
            width: 24px;
            height: 24px;
            transition: all 0.5s ease;
          }

          .searchLogoLeft {
            left: 70px !important;
          }
        }

        .searchList {
          position: absolute;
          z-index: 999;
          margin-top: 4px;
          padding: 7px 0;
          width: 480px;
          background: rgb(255, 255, 255);
          box-shadow: 2px 6px 14px 8px rgba(47, 47, 47, 0.1);
          border-radius: 10px;
          box-sizing: border-box;
          // filter: blur(20px);
          .item {
            padding-left: 30px;
            width: 480px;
            height: 36px;
            line-height: 36px;
            box-sizing: border-box;
          }

          .item:hover {
            background: #e6e6e6;
          }
        }

        .searchListMask {
          position: fixed;
          top: 0;
          left: 0;
          z-index: 100;
          width: 100vw;
          height: 100vh;
          background-color: rgba(255, 255, 255, 0);
        }
      }

      .goHome,
      .goHistory {
        display: flex;
        align-items: center;
        margin-right: 37px;
        height: 18px;
        font-size: 18px;
        color: #666666;

        .goHistoryContent {
          display: flex;
          align-items: center;

          .lr {
            font-size: 18px;
            height: 18px;
            line-height: 18px;
          }
        }

        img {
          margin-top: -2px;
          margin-right: 10px;
          width: 18px;
          height: 18px;
        }

        > span {
          font-size: 18px;
          height: 18px;
          line-height: 18px;
        }
      }

      .goHistory {
        position: relative;
        flex-direction: column;

        .LRContainor {
          display: none;
          // display: flex;
          flex-direction: column;
          align-items: center;
          position: absolute;
          z-index: 999;
          top: 18px;

          .LRList {
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 20px 0;
            width: 278px;
            // height: 587px;
            background-color: #fff;
            box-shadow: 2px 6px 14px 8px rgba(47, 47, 47, 0.1);
            border-radius: 15px;
            box-sizing: border-box;
            // filter: blur(20px);
            .cardImg {
              position: relative;
              margin-bottom: 30px;
              width: 238px;
              height: 133px;
              // background: #000000;
              border-radius: 16px;
              overflow: hidden;
              // opacity: 0.3;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
              }

              .mask {
                display: none;
                // display: flex;
                justify-content: center;
                align-items: center;
                position: absolute;
                z-index: 9;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.3);

                .maskTitle {
                  width: 80px;
                  height: 30px;
                  line-height: 30px;
                  background: #ffffff;
                  color: #333333;
                  font-size: 14px;
                  border-radius: 15px;
                  text-align: center;
                }
              }
            }

            .cardImg:hover {
              .mask {
                display: flex;
              }
            }

            .cardText {
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin-bottom: 20px;
              padding: 0 20px;
              width: 100%;

              .title {
                font-size: 20px;
                color: #333333;
                font-weight: 600;
              }

              .clear {
                display: flex;
                align-items: center;
                font-size: 14px;
                color: #999999;

                img {
                  margin-right: 5px;
                  width: 14px;
                  height: 14px;
                }

                span {
                  height: 14px;
                  line-height: 14px;
                  font-size: 14px;
                }
              }
            }

            .cardList1 {
              display: flex;
              flex-direction: column;

              .cardItem {
                display: flex;
                // justify-content: space-between;
                align-items: center;
                position: relative;
                // margin-right: 70px;
                margin-bottom: 10px;
                width: 238px;
                height: 66px;
                background: #ffffff;
                border: 1px solid #eee;
                border-radius: 15px;

                .logo {
                  margin-left: -6px;
                  width: 51px;
                  height: 29px;
                }

                .classLevelName {
                  position: absolute;
                  top: 22px;
                  left: 0;
                  height: 12px;
                  line-height: 12px;
                  font-size: 12px;
                  color: #666666;
                  transform: scale(0.8);
                }

                .cont {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                  margin-left: 10px;
                  width: 183px;

                  > div {
                    .title {
                      width: 130px;
                      font-size: 16px;
                      color: #666666;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                    }

                    .updateTime {
                      display: flex;
                      align-items: center;
                      margin-top: 5px;
                      font-size: 12px;

                      img {
                        width: 12px;
                        height: 12px;
                      }
                    }
                  }

                  .close {
                    display: none;
                    margin-right: 20px;
                    width: 16px;
                  }
                }
              }

              .cardItem:hover {
                border: 0;
                box-shadow: 2px 6px 20px 4px rgba(2, 55, 92, 0.08);

                .close {
                  width: 12px;
                  height: 12px;
                  display: block;
                }

                .cont {
                  .title {
                    color: #333 !important;
                    font-weight: 550;
                  }
                }
              }
            }
          }

          .lookAll {
            width: 130px;
            height: 36px;
            line-height: 36px;
            background: #ffffff;
            border-radius: 18px;
            border: 1px solid #ff6f5b;
            color: #ff6f5b;
            font-size: 18px;
            text-align: center;
          }
        }
      }

      .goHistory:hover {
        .LRContainor {
          display: flex;
        }
      }

      .goHistoryed {
        font-weight: 600;
      }

      .goUserInfo {
        display: flex;
        align-items: center;

        span {
          margin-right: 14px;
          font-size: 24px;
          font-weight: 550;
          color: #525252;
        }

        .minCont {
          position: relative;
          z-index: 999;

          .miniAvatar {
            width: 40px;
            height: 40px;
            object-fit: cover;
            border-radius: 50%;
          }

          .infoContent {
            display: none;
            // display: flex;
            flex-direction: column;
            align-items: center;
            position: absolute;
            top: 40px;
            left: -40px;

            .infoList {
              width: 120px;
              // height: 160px;
              background-color: #fff;
              box-shadow: 2px 6px 14px 8px rgba(47, 47, 47, 0.1);
              border-radius: 10px;
              overflow: hidden;
              // filter: blur(20px);
              .infoItem {
                width: 120px;
                height: 44px;
                line-height: 44px;
                text-align: center;
                background-color: #fff;
              }

              .infoItem:hover {
                background: #f3f3f3;
              }
            }
          }
        }

        .minCont:hover {
          .infoContent {
            display: flex;
          }
        }
      }
    }
  }
}
</style>
